import { AppBar, Divider, Stack, Toolbar } from "@mui/material";
import AddressLink from '../links/AddressLink';
import SocialButtons from "../links/SocialButtons";

function BottomNavBar({ ...props}) {
  return (
    <AppBar position="relative" color="primary" sx={{ top: 'auto', bottom: 0, mx: 'auto', bgcolor: "grey.600" }}>
      <Toolbar sx={{ width: "100%", display: "flex", justifyContent: "center", textAlign: "center" }}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 1, sm: 3 }} sx={{ py: 1 }} justifyContent="center" alignItems="center">
          <SocialButtons size="small" />
          <Divider orientation="vertical" variant="middle" flexItem sx={{ xs: { display: 'none' }}} />
          <AddressLink />
        </Stack>
      </Toolbar>
    </AppBar>
  )
}  

export default BottomNavBar;